export const TransformDate = (inputDate) => {
  const [day, month, year] = inputDate.split('/');
  return `${year}-${month}-${day}`;
};